<script lang="ts">
  import AnimatedIcon from "../../icon/v1/AnimatedIcon.svelte";
  import type { Props } from "./IconButtonV4.types.ts";
  import { useHost } from "../../../common/runtime/utils/useHost.ts";

  let { icon, loading }: Props = $props();

  const Host = useHost();

  const handleClick = (event: MouseEvent): void => {
    if (!loading) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  };

  Host.addEventListener("click", handleClick, { capture: true });
  /*                                                        */
  /*                                                                                                 */
  Host.addEventListener("auxclick", handleClick, { capture: true });

  $effect(() => {
    const slotElement = Host.firstElementChild;
    if (!slotElement) return;

    if (loading) {
      slotElement.setAttribute("aria-busy", "true");
      slotElement.setAttribute("aria-disabled", "true");
    } else {
      slotElement.removeAttribute("aria-busy");
      slotElement.removeAttribute("aria-disabled");
    }
  });
</script>

<slot />
<AnimatedIcon type={icon} />

<style lang="scss">
  :global {
    svg {
      position: absolute;
      inset: 0;
      margin: auto;
      overflow: visible;
      width: var(--_icon-size);
      height: var(--_icon-size);
      color: var(--_icon-color);
      opacity: 1;
    }
  }
</style>
